export default __webpack_public_path__ + "static/orchestra-2-673b45e28ec33eb4778f139bf422b3b4.jpg";